import React from 'react'
import { Grid, Typography } from '@mui/material'
import { AccountType, ResultObjectType } from '@cbgms/api'
import { capitalizeFirstCharacter } from '@cbgms/base/utils/helpers'
import { useTranslation } from 'react-i18next'
import { useSearchResultTypeContext } from '../../context/SearchResultTypeContext'

export interface ResultTitleProps {
  resultType: ResultObjectType | AccountType
  isTitleVisible: boolean
}

export const ResultTitle: React.FC<ResultTitleProps> = props => {
  const { isPortal } = useSearchResultTypeContext()
  const { t } = useTranslation()
  const { resultType, isTitleVisible } = props
  const suffix = isPortal && resultType === ResultObjectType.WorkOrder ? '_portal' : ''
  const typeTranslation = (Object.values(ResultObjectType) as string[]).includes(resultType.toString())
    ? t(`Enum.EnumResultObjectType_${resultType}${suffix}`)
    : t(`DashboardSearch.AccountType_${resultType}`)

  if (!isTitleVisible) {
    return null
  }

  return (
    <Grid item xs={12}>
      <Typography variant='body1' component='h3' style={{ fontWeight: 'bold' }}>
        {capitalizeFirstCharacter(typeTranslation)}
      </Typography>
    </Grid>
  )
}
